import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { InfoOutlinedIcon } from '@/components/icons/InfoOutlined'
import { Icon } from '@/components/ui'

export const CartDateErrorMessage = () => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx('tw-flex tw-items-center tw-justify-end tw-space-x-2')}
    >
      <Icon icon={InfoOutlinedIcon} size={'md'} color={'alert'} />
      <div className={clsx('tw-flex tw-text-left')}>
        <span>{t('cart.date.error.updated')}</span>
      </div>
    </div>
  )
}
